// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-shim'
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// common css
import './lib/common.js'
import './assets/css/base.css'
import VueLazyload from 'vue-lazyload'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueLazyload, {
  loading: require('./assets/images/loading.png'),
  preLoad:1.2,
  attempt:2
})
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    navbar:false
  }
})
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if(process.env.NODE_ENV === 'production'){
  Sentry.init({
    dsn: 'http://65b3b641323f48db90ed554bc6b10af8@zsy-sentry.zhixinhuixue.net/15',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js